export default "__VITE_ASSET__C2U19D76__"